import Axios from "./axios";

const resource = "shop-plans";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}